export enum ScheduledMessageStatusEnum {
  Scheduled = 'SCHEDULED',
  Sent = 'SENT',
  Failed = 'FAILED',
  Cancelled = 'CANCELLED',
  Skipped = 'SKIPPED',
}
